import { render, staticRenderFns } from "./InfoBubble.vue?vue&type=template&id=82d3fa18&scoped=true"
import script from "./InfoBubble.vue?vue&type=script&lang=js"
export * from "./InfoBubble.vue?vue&type=script&lang=js"
import style0 from "./InfoBubble.vue?vue&type=style&index=0&id=82d3fa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d3fa18",
  null
  
)

export default component.exports